/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cc_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's the difference between title case and sentence case?`)
};

const es_cc_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es la diferencia entre Title Case y Sentence case?`)
};

const de_cc_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist der Unterschied zwischen Title Case und Sentence case?`)
};

const nl_cc_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is het verschil tussen titeltekst en zintekst?`)
};

const fr_cc_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est la différence entre casse titre et casse phrase ?`)
};

const it_cc_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è la differenza tra title case e sentence case?`)
};

const pt_br2_cc_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre título e caso de sentença?`)
};

const pt_cc_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre caso de título e caso de sentença?`)
};

const ja_cc_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`title case と sentence case の違いは何ですか？`)
};

const zh_cc_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标题格式和句首大写格式有什么区别？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cc_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cc_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cc_faq3_q", locale)
	if (locale === "en") return en_cc_faq3_q(inputs)
	if (locale === "es") return es_cc_faq3_q(inputs)
	if (locale === "de") return de_cc_faq3_q(inputs)
	if (locale === "nl") return nl_cc_faq3_q(inputs)
	if (locale === "fr") return fr_cc_faq3_q(inputs)
	if (locale === "it") return it_cc_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_cc_faq3_q(inputs)
	if (locale === "pt") return pt_cc_faq3_q(inputs)
	if (locale === "ja") return ja_cc_faq3_q(inputs)
	return zh_cc_faq3_q(inputs)
};